import React, { useState } from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { HPSwitch } from '../SwitchToggle';

import { useCopilotStyles } from './styles';
import { useCopilotContext } from '../../contexts/CopilotContext';

import { AI_MODES_IDX } from '../../global/constants/general';

const { SEARCH } = AI_MODES_IDX;

interface SelectModelProps {
  aiModeIndex?: number;
  hideSearchTextResults?: boolean;
  setHideSearchTextResults?: (_: boolean) => void;
  onChange?: () => void;
}

const SelectModel: React.FC<SelectModelProps> = ({
  aiModeIndex,
  hideSearchTextResults,
  setHideSearchTextResults,
  onChange,
}) => {
  const styles = useCopilotStyles();
  const { filterModel, setFilterModel, filterModelList } = useCopilotContext();

  const classifierModels: string[] = ['mpnet', 'sbert', 'e5'];
  const [classifierModel, setClassifierModel] = useState<number>(0);

  const handleModelChange = (event: any) => {
    console.log('handleModelChange:', event);

    if (aiModeIndex === -1)
      //this should be 0
      setClassifierModel(event.target.value);
    else setFilterModel(event.target.value);

    if (onChange) onChange();
  };

  const toggleHideSearchTextResults = () => {
    if (!setHideSearchTextResults) return;
    setHideSearchTextResults(!hideSearchTextResults);
  };

  return (
    <FormControl
      component="fieldset"
      style={{ float: 'right', display: 'flex', flexDirection: 'row' }}>
      {aiModeIndex === SEARCH && (
        <FormControlLabel
          control={
            <HPSwitch
              checked={!hideSearchTextResults}
              onChange={toggleHideSearchTextResults}
            />
          }
          label="Text"
          labelPlacement="start"
          sx={{
            mr: '1rem',
            padding: '0px',
            '.MuiOutlinedInput-input': {
              padding: '.75rem',
            },
          }}
        />
      )}
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel
          id="select-label"
          shrink
          sx={{ backgroundColor: '#eee', padding: '0 .5rem' }}>
          Model
        </InputLabel>
        <Select
          labelId="select-label"
          sx={styles.select}
          value={aiModeIndex === -1 ? classifierModel : filterModel}
          onChange={handleModelChange}>
          {(aiModeIndex === -1 ? classifierModels : filterModelList).map(
            (model, index) => (
              <MenuItem key={index} value={index}>
                {model.toUpperCase()}
              </MenuItem>
            ),
          )}
        </Select>
      </FormControl>
    </FormControl>
  );
};

export default SelectModel;
